const imageMap = {
  footLogo: {
    HAIERMALL: 'https://obs.pricoo.pk/69f2fa0d.png',
    PRICOO: 'https://obs.pricoo.pk/5211e9cc.png'
  },
  headLogo: {
    HAIERMALL: 'https://obs.pricoo.pk/f1ae18fb.png',
    PRICOO: 'https://obs.pricoo.pk/7947a91d.png'
  },
  loginLogo: {
    HAIERMALL: 'https://obs.pricoo.pk/38c3af48.png',
    PRICOO: 'https://obs.pricoo.pk/7c0eecf0.png'
  },
  loginCart: {
    HAIERMALL: 'https://obs.pricoo.pk/e4207aff.png',
    PRICOO: 'https://obs.pricoo.pk/abe8b7bd.png'
  },
  LogoIntroduce: {
    HAIERMALL: `Haier has become the No. 1 home appliance brand in Pakistan. Currently, Haier Air Conditioner is ranked #1 in market share for numerous years along with Haier
                Washing Machine.`,
    PRICOO: `In a laoreet purus. Integer turpis quam, laoreet id orci nec, ultrices lacinia nunc. Aliquam erat vo. In a laoreet purus. Integer turpis quam, laoreet id orci nec, ultrices lacinia nunc. Aliquam erat vo`
  },
  kefuTel: {
    HAIERMALL: '(042) 111 142 437',
    PRICOO: '0314-444-2427'
  }
}

export const diffData = {
  helpCenter: {
    HAIERMALL: {
      Whatsapp: { type: 'Whatsapp', name: '客服', en_name: 'Whatsapp', icon: 'icon-tel', sup: '+92 3142437444' },
      Email: { type: 'Email', name: '邮箱', en_name: 'Email', icon: 'icon-subtract', sup: 'support@haiermall.pk' },
      Support: { type: 'Support', name: '帮助', en_name: 'Support', icon: 'customer-service', sup: '042-111142437' }
    },
    PRICOO: {
      Whatsapp: { type: 'Whatsapp', name: '客服', en_name: 'Whatsapp', icon: 'icon-tel', sup: '+92 3028653032' },
      Email: { type: 'Email', name: '邮箱', en_name: 'Email', icon: 'icon-subtract', sup: 'support@pricoo.pk' },
      Support: { type: 'Support', name: '帮助', en_name: 'Support', icon: 'icon-customer-service', sup: '+92 3041117004' }
    }
  },
  youxiang: {
    HAIERMALL: 'info@haier.com.pk', 
    PRICOO: 'support@pricoo.pk'
  },
  footer: {
    HAIERMALL: {
      name: 'Haier',
      year: new Date().getFullYear(),
      tel: '(042) 111 142 437',
    },
    PRICOO: {
      name: 'Pricoo',
      year: new Date().getFullYear(),
      tel: '0304 1117 004'
    }
  }
}

export function getDiffImage(imageKey) {
  const systemImages = imageMap[imageKey]
  if (!systemImages) {
    console.warn(`Image key ${imageKey} not found in imageMap`)
    return
  }
  const systemType = process.env.VUE_APP_HOME_NAME
  return systemImages[systemType]
}

export function getDiffData(obj) {
  if (!obj) {
    console.warn(`当前对象不存在`)
    return
  }
  const systemType = process.env.VUE_APP_HOME_NAME
  return obj[systemType]
}
